var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M5.978.133a1.224 1.224 0 0 0-1.216 1.095l-1.715.015-.358.132-.062.564.538.066-.044.486-.07.632c-.592.031-1.133.134-1.54.479C.918 4.105.553 4.8.553 5.567c0 1.535 1.465 2.779 3.275 2.779 1.81 0 3.276-1.244 3.276-2.78 0-.766-.367-1.461-.96-1.964-.4-.34-.876-.444-1.421-.477l-.138-.399-.07-.44.542-.075 2.215 1.922.238 3.34.546-.004-.286-3.615-1.457-1.318a1.224 1.224 0 0 0 .89-1.178A1.224 1.224 0 0 0 5.977.133Zm0 .455a.77.77 0 0 1 .771.77.77.77 0 0 1-.77.77.77.77 0 0 1-.13-.011l-.614-.556a.77.77 0 0 1-.028-.203.77.77 0 0 1 .771-.77Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.b112da05f894c69c7c17bfe67e46fb0d.svg";
export { ForwardRef as ReactComponent };